import { AxiosError } from "axios";

import { useQuery, UseQueryOptions, useMutation } from "@tanstack/react-query";

import { DefaultApiError } from "../types";
import { fetchTicketsAtendimento, fetchTicketsDesenvolvimento, fetchTicketsHistoricoTransacao, fetchTicketsOrdemServico, fetchTicketDetails, exportTicketsAtendimento, exportTicketsDesenvolvimento, exportTicketsOrdemServico, exportTicketsHistoricoTransacao, addTicketPriority, creatDirectChannelRequest, fetchPriorityTicketsAtendimento, fetchPriorityTicketsDesenvolvimento, fetchPriorityTicketsOrdemServico, fetchTicketReferenciaExterna, fetchAttachmentTicket } from ".";
import { AddTicketPriorityRequest, AttachmentTicketsResponse, PriorityTicketResponse, TicketHistoricoResponse, TicketReferenciaExterna, TicketRequest, TicketResponse } from "../../types/tickets/types";

export const useTicketsAtendimento = (
    filters: TicketRequest,
    options?: Partial<UseQueryOptions<TicketResponse, AxiosError<DefaultApiError>>>
) => useQuery<TicketResponse, AxiosError<DefaultApiError>>({
    queryKey: ['ticketsAtendimento', filters],
    queryFn: () => fetchTicketsAtendimento(filters),
    ...options,
});


export const usePriorityTicketsAtendimento = (
    oidCliente: number,
    options?: Partial<UseQueryOptions<PriorityTicketResponse[], AxiosError<DefaultApiError>>>
) => useQuery<PriorityTicketResponse[], AxiosError<DefaultApiError>>({
    queryKey: ['priorityTicketsAtendimento', oidCliente],
    queryFn: () => fetchPriorityTicketsAtendimento(oidCliente),
    ...options,
});


export const useTicketsDesenvolvimento = (
    filters: TicketRequest,
    options?: Partial<UseQueryOptions<TicketResponse, AxiosError<DefaultApiError>>>
) => useQuery<TicketResponse, AxiosError<DefaultApiError>>({
    queryKey: ['ticketsDesenvolvimento', filters],
    queryFn: () => fetchTicketsDesenvolvimento(filters),
    ...options,
});


export const usePrioriryTicketsDesenvolvimento = (
    oidCliente: number,
    options?: Partial<UseQueryOptions<PriorityTicketResponse[], AxiosError<DefaultApiError>>>
) => useQuery<PriorityTicketResponse[], AxiosError<DefaultApiError>>({
    queryKey: ['priorityTicketsDesenvolvimento', oidCliente],
    queryFn: () => fetchPriorityTicketsDesenvolvimento(oidCliente),
    ...options,
});


export const useAttachmentTicket = (
    numeroTopicoPreAtendimento: number,
    options?: Partial<UseQueryOptions<AttachmentTicketsResponse, AxiosError<DefaultApiError>>>
) => useQuery<AttachmentTicketsResponse, AxiosError<DefaultApiError>>({
    queryKey: ['getAttachmentTicket', numeroTopicoPreAtendimento],
    queryFn: () => fetchAttachmentTicket(numeroTopicoPreAtendimento),
    ...options,
});


export const useTicketsOrdemServico = (
    filters: TicketRequest,
    options?: Partial<UseQueryOptions<TicketResponse, AxiosError<DefaultApiError>>>
) => useQuery<TicketResponse, AxiosError<DefaultApiError>>({
    queryKey: ['ticketsOrdemServico', filters],
    queryFn: () => fetchTicketsOrdemServico(filters),
    ...options,
});


export const usePrioriryTicketsOrdemServico = (
    oidCliente: number,
    options?: Partial<UseQueryOptions<PriorityTicketResponse[], AxiosError<DefaultApiError>>>
) => useQuery<PriorityTicketResponse[], AxiosError<DefaultApiError>>({
    queryKey: ['priorityTicketsOrdemServico', oidCliente],
    queryFn: () => fetchPriorityTicketsOrdemServico(oidCliente),
    ...options,
});


export const useTicketsHistoricoTransacao = (
    filters: TicketRequest,
    options?: Partial<UseQueryOptions<TicketResponse, AxiosError<DefaultApiError>>>
) => useQuery<TicketResponse, AxiosError<DefaultApiError>>({
    queryKey: ['ticketsHistoricoTransacao', filters],
    queryFn: () => fetchTicketsHistoricoTransacao(filters),
    ...options,
});

export const useTicketDetails = (
    ticketId: number,
    options?: Partial<UseQueryOptions<TicketHistoricoResponse, AxiosError<DefaultApiError>>>
) => useQuery<TicketHistoricoResponse, AxiosError<DefaultApiError>>({
    queryKey: ['ticketDetails', ticketId],
    queryFn: () => fetchTicketDetails(ticketId),
    ...options,
});


export const useFetchTicketReferenciaExterna = (
    referenciaExterna?: string,
    options?: Partial<UseQueryOptions<TicketReferenciaExterna, AxiosError<DefaultApiError>>>
) => useQuery<TicketReferenciaExterna, AxiosError<DefaultApiError>>({
    queryKey: ['ticketDetailReferenciaExterna', referenciaExterna],
    queryFn: () => {
        if (!referenciaExterna) {
            throw new Error('Referencia externa não informado');
        }
        return fetchTicketReferenciaExterna(referenciaExterna);
    },
    ...options,
});


export const useExportTicketsAtendimento = () =>
    useMutation<Blob, AxiosError<DefaultApiError>, TicketRequest>({
        mutationFn: exportTicketsAtendimento,
    })

export const useExportTicketsDesenvolvimento = () =>
    useMutation<Blob, AxiosError<DefaultApiError>, TicketRequest>({
        mutationFn: exportTicketsDesenvolvimento,
    })
export const useExportTicketsOrdemServico = () =>
    useMutation<Blob, AxiosError<DefaultApiError>, TicketRequest>({
        mutationFn: exportTicketsOrdemServico,
    })
export const useExportTicketsHistoricoTransacao = () =>
    useMutation<Blob, AxiosError<DefaultApiError>, TicketRequest>({
        mutationFn: exportTicketsHistoricoTransacao,
    })
export const useCreatDirectChannelRequest = () =>
    useMutation<void, AxiosError<DefaultApiError>, number>({
        mutationFn: creatDirectChannelRequest,
    })
export const useAddTicketPriority = () =>
    useMutation<void, AxiosError<DefaultApiError>, AddTicketPriorityRequest>({
        mutationFn: addTicketPriority,
    })